import { VoucherPrintOrgHeading, VoucherPrintOrgAddress, VoucherPrintDepartmentFooter } from "../VoucherPrintOrgHeader";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import {
  VOUCHER_INVOICE_TYPE,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import { formatMoney, getDateTime, getPrintPatientCode } from "app/common/LocalFunction";
import { toVietnamese } from "app/common/utils/VNUtils";
import React, { memo } from "react";
import QrSurveySection from "app/common/Component/Print/QrSurveySection";

const PrintFormReceiptA5 = ({
  componentRef,
  dataVoucherFee,
  initialPatient,
  staffRevenues,
}) => {
  const namesText = staffRevenues
    ?.map((item) => item?.staff?.staffName)
    .join(" ; ");

  return (
    <>
      <PrintCommon
        ref={componentRef}
        marginPage="8mm"
        hidden={false}
        size="A5"
        // orientation={"portrait"}
        orientation={"landscape"}
      >
        <div className="wraper-print">
          <div
            className="container-print text-[14px] leading-6"
            style={{ maxWidth: "730px" }}
          >
            <div>
              <VoucherPrintOrgHeading
                department={dataVoucherFee?.department}
                withDepartmentName
                as="h4"
                style={{ fontWeight: 600 }}
              />
              <VoucherPrintOrgAddress
                department={dataVoucherFee?.department}
                phonePrefix="Tel: "
                addressOverride={
                  dataVoucherFee?.department?.organization?.name
                    ? `Add: ${dataVoucherFee?.department?.organization?.name}`
                    : "Add: "
                }
                phoneOverride=""
                style={{ textAlign: "left" }}
              />
            </div>

            <div className="text-center mt-3">
              <h3 className="font-bold text-[18px]">
                PHIẾU{" "}
                {dataVoucherFee?.voucherInvoiceType ===
                  VOUCHER_INVOICE_TYPE_VALUE.Refund
                  ? "HOÀN TIỀN"
                  : "THU"}
              </h3>
              <div>{getDateTime(dataVoucherFee?.voucherDate, "", "DD/MM/YYYY")}</div>
            </div>

            <div style={{ marginTop: "12px" }}>
              <table
                className="info-print"
                style={{
                  borderCollapse: "collapse",
                  fontSize: "13px",
                  lineHeight: "1.6",
                  minWidth: "420px", // đảm bảo không bị bó hẹp
                }}
              >
                <tbody>
                  <tr>
                    <td style={{ width: "40%", padding: "2px 6px" }}>
                      Số phiếu:
                    </td>
                    <td style={{ width: "60%", padding: "2px 6px" }}>
                      {dataVoucherFee?.code || "Chưa có mã"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "2px 6px" }}>Người nộp tiền:</td>
                    <td style={{ padding: "2px 6px" }}>
                      {dataVoucherFee?.patient?.displayName || ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "2px 6px" }}>Mã KH:</td>
                    <td style={{ padding: "2px 6px" }}>
                      {getPrintPatientCode(dataVoucherFee?.patient, initialPatient)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "2px 6px" }}>NV tư vấn:</td>
                    <td style={{ padding: "2px 6px" }}>{namesText}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: "2px 6px" }}>Lý do:</td>
                    <td style={{ padding: "2px 6px" }}></td>
                  </tr>
                  <tr>
                    <td style={{ padding: "2px 6px" }}>Số tiền:</td>
                    <td style={{ padding: "2px 6px", fontWeight: "bold" }}>
                      {formatMoney(dataVoucherFee?.customerPaidAmount || 0)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "2px 6px" }}>(Viết bằng chữ):</td>
                    <td style={{ padding: "2px 6px", fontStyle: "italic" }}>
                      {toVietnamese(dataVoucherFee?.customerPaidAmount || "")}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "2px 6px" }}>Ghi chú:</td>
                    <td style={{ padding: "2px 6px" }}>
                      {dataVoucherFee?.note || ""}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ padding: "2px 6px" }}>
                      <div style={{ display: "flex", width: "100%" }}>
                        <span style={{ width: "30%" }}>Kèm theo:</span>
                        <span style={{ width: "70%" }}>Chứng từ gốc:</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              style={{
                display: "flex",
                gap: "115px",
                marginTop: "20px",
                textAlign: "center",
              }}
            >
              <div>
                <div style={{ fontWeight: "bold" }}>Giám Đốc/Quản Lý CN</div>
                <div className="text-sm">(ký, họ tên)</div>
              </div>
              <div>
                <div style={{ fontWeight: "bold" }}>Người chi tiền</div>
                <div className="text-sm">(ký, họ tên)</div>
              </div>
              <div>
                <div style={{ fontWeight: "bold" }}>Người lập phiếu</div>
                <div className="text-sm">(ký, họ tên)</div>
              </div>
              <div>
                <div style={{ fontWeight: "bold" }}>Người nhận tiền</div>
                <div className="text-sm">(ký, họ tên)</div>
              </div>
            </div>

            <div style={{ display: "flex", width: "100%", marginTop: "50px" }}>
              <div style={{ width: "24%" }}>Đã nhận đủ số tiền bằng chữ: </div>
              <div style={{ width: "76%", borderBottom: "1px dotted" }}>
                {toVietnamese(dataVoucherFee?.customerPaidAmount)}
              </div>
            </div>

            <div
              style={{
                marginTop: "16px",
                fontSize: "12px",
                lineHeight: "1.5",
                textAlign: "center",
                textTransform: "uppercase",
                fontStyle: "italic",
              }}
            >
              <i>
                Quý khách vui lòng kiểm tra dịch vụ/sản phẩm trước khi rời
                khỏi quầy. Sản phẩm sẽ không được đổi trả. Khi khách hàng tự
                ý ngưng dịch vụ sẽ không được hoàn lại tiền mà sẽ được tư vấn
                chuyển sang dịch vụ khác. Dịch vụ có thời hạn sử dụng trong
                vòng 12 tháng kể từ thời điểm thu tiền và xuất hóa đơn. Xin
                cảm ơn Quý khách và hẹn gặp lại !!!
              </i>
            </div>
            <QrSurveySection patient={dataVoucherFee?.patient} />
          </div>
        </div>
      </PrintCommon>
    </>
  );
};

export default memo(PrintFormReceiptA5);
